// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OrderServiceReference_modal__kWLhI {
  align-items: flex-end;
  padding: 12px;
}
@media (min-width: 640px) {
  .OrderServiceReference_modal__kWLhI {
    padding: 66px 40px 40px;
  }
}
.OrderServiceReference_modal__kWLhI .modal__title::first-letter {
  text-transform: capitalize;
}

.OrderServiceReference_block__XCA\\+z {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex-wrap: wrap;
  grid-gap: 8px;
  align-self: flex-start;
  max-width: 100%;
}
@media (min-width: 640px) {
  .OrderServiceReference_block__XCA\\+z {
    flex-direction: row;
    align-items: center;
  }
}
.OrderServiceReference_block__XCA\\+z.OrderServiceReference_error__WUMeq .OrderServiceReference_btn__OOSCP {
  border-color: var(--error);
}

button.OrderServiceReference_btn__OOSCP {
  border: 1px solid transparent;
  color: var(--text-color);
  font-size: 14px;
  line-height: normal;
  font-weight: normal;
  height: 40px;
  border-radius: 8px;
  padding-left: 12px;
  padding-right: 12px;
  width: auto;
}
button.OrderServiceReference_btn__OOSCP svg {
  color: var(--accent-color);
  flex-shrink: 0;
  margin-right: 11px;
  transition: 0.2s;
}
@media (hover: hover) {
  button.OrderServiceReference_btn__OOSCP:hover svg {
    color: var(--white);
  }
}

.OrderServiceReference_currentUser__EMn0E {
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  max-width: 100%;
  min-height: 38px;
  background-color: #fafafa;
  padding: 4px 10px;
}

.OrderServiceReference_currentUserName__JmpbH {
  overflow: hidden;
  text-overflow: ellipsis;
}

.OrderServiceReference_object_item-text__4F-kQ {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.OrderServiceReference_pathName__PuJQQ {
  font-size: 12px;
  line-height: 114%;
  color: #7A808B;
}

.OrderServiceReference_currentUserBtn__Zs\\+P9 {
  width: 16px;
  height: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  margin-left: 10px;
  transition: var(--transition);
}
.OrderServiceReference_currentUserBtn__Zs\\+P9 svg {
  fill: #A2A7AF;
}
@media (hover: hover) {
  .OrderServiceReference_currentUserBtn__Zs\\+P9:hover svg {
    fill: currentColor;
  }
}

.OrderServiceReference_errorTxt__qSiWh {
  position: absolute;
  left: 0;
  top: calc(100% + 4px);
  color: var(--error);
  font-size: 12px;
  line-height: 14px;
  pointer-events: none;
  white-space: nowrap;
}`, "",{"version":3,"sources":["webpack://./src/components/OrderService/OrderServiceReference/OrderServiceReference.module.scss"],"names":[],"mappings":"AAAA;EACE,qBAAA;EACA,aAAA;AACF;AACE;EAJF;IAKI,uBAAA;EAEF;AACF;AAGQ;EACE,0BAAA;AADV;;AAQA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;AALF;AAOE;EATF;IAUI,mBAAA;IACA,mBAAA;EAJF;AACF;AAOI;EACE,0BAAA;AALN;;AAUA;EACE,6BAAA;EACA,wBAAA;EACA,eAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;AAPF;AASE;EACE,0BAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AAPJ;AAUE;EAEI;IACE,mBAAA;EATN;AACF;;AAcA;EACE,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,iBAAA;AAXF;;AAcA;EACE,gBAAA;EACA,uBAAA;AAXF;;AAcA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAXF;;AAcA;EACE,eAAA;EACA,iBAAA;EACA,cAAA;AAXF;;AAcA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,iBAAA;EACA,6BAAA;AAXF;AAaE;EACE,aAAA;AAXJ;AAcE;EAEI;IACE,kBAAA;EAbN;AACF;;AAkBA;EACE,kBAAA;EACA,OAAA;EACA,qBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,mBAAA;AAfF","sourcesContent":[".modal {\r\n  align-items: flex-end;\r\n  padding: 12px;\r\n\r\n  @media (min-width: 640px) {\r\n    padding: 66px 40px 40px;\r\n  }\r\n\r\n  :global {\r\n    .modal {\r\n      &__title {\r\n        &::first-letter {\r\n          text-transform: capitalize;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.block {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: flex-start;\r\n  flex-wrap: wrap;\r\n  grid-gap: 8px;\r\n  align-self: flex-start;\r\n  max-width: 100%;\r\n\r\n  @media (min-width: 640px) {\r\n    flex-direction: row;\r\n    align-items: center;\r\n  }\r\n\r\n  &.error {\r\n    .btn {\r\n      border-color: var(--error);\r\n    }\r\n  }\r\n}\r\n\r\nbutton.btn {\r\n  border: 1px solid transparent;\r\n  color: var(--text-color);\r\n  font-size: 14px;\r\n  line-height: normal;\r\n  font-weight: normal;\r\n  height: 40px;\r\n  border-radius: 8px;\r\n  padding-left: 12px;\r\n  padding-right: 12px;\r\n  width: auto;\r\n\r\n  svg {\r\n    color: var(--accent-color);\r\n    flex-shrink: 0;\r\n    margin-right: 11px;\r\n    transition: 0.2s;\r\n  }\r\n\r\n  @media (hover: hover) {\r\n    &:hover {\r\n      svg {\r\n        color: var(--white);\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.currentUser {\r\n  border-radius: 8px;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  max-width: 100%;\r\n  min-height: 38px;\r\n  background-color: #fafafa;\r\n  padding: 4px 10px;\r\n}\r\n\r\n.currentUserName {\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.object_item-text {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 3px;\r\n}\r\n\r\n.pathName {\r\n  font-size: 12px;\r\n  line-height: 114%;\r\n  color: #7A808B;\r\n}\r\n\r\n.currentUserBtn {\r\n  width: 16px;\r\n  height: 16px;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  flex-shrink: 0;\r\n  margin-left: 10px;\r\n  transition: var(--transition);\r\n\r\n  svg {\r\n    fill: #A2A7AF;\r\n  }\r\n\r\n  @media (hover: hover) {\r\n    &:hover {\r\n      svg {\r\n        fill: currentColor;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.errorTxt {\r\n  position: absolute;\r\n  left: 0;\r\n  top: calc(100% + 4px);\r\n  color: var(--error);\r\n  font-size: 12px;\r\n  line-height: 14px;\r\n  pointer-events: none;\r\n  white-space: nowrap;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `OrderServiceReference_modal__kWLhI`,
	"block": `OrderServiceReference_block__XCA+z`,
	"error": `OrderServiceReference_error__WUMeq`,
	"btn": `OrderServiceReference_btn__OOSCP`,
	"currentUser": `OrderServiceReference_currentUser__EMn0E`,
	"currentUserName": `OrderServiceReference_currentUserName__JmpbH`,
	"object_item-text": `OrderServiceReference_object_item-text__4F-kQ`,
	"pathName": `OrderServiceReference_pathName__PuJQQ`,
	"currentUserBtn": `OrderServiceReference_currentUserBtn__Zs+P9`,
	"errorTxt": `OrderServiceReference_errorTxt__qSiWh`
};
export default ___CSS_LOADER_EXPORT___;
